import React from 'react';

const TermsAndConditions = () => {
    const supportEmail = "support@shopysync.com";
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">

                    <h1 className="display-5 fw-bold text-teal mb-4">Terms & Conditions</h1>
                    <p className="text-muted mb-5">Last updated: January 22, 2026</p>

                    {/* 1. Acceptance */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">1. Acceptance of Terms</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            By installing or using <strong>Shopy Sync</strong> (the "App"), you agree to be bound by these Terms & Conditions.
                            If you do not agree, please do not install or use the App.
                        </p>
                    </section>

                    {/* 2. App Purpose */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">2. App Purpose</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            Shopy Sync allows you to sync product data between <strong>Google Sheets</strong> and your <strong>Shopify store</strong> for bulk add, update, and delete operations.
                        </p>
                    </section>

                    {/* 3. User Responsibilities */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">3. Your Responsibilities</h2>
                        <ul className="list-unstyled text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                            <li className="mb-2">• You must own or have permission to edit the Google Sheet and Shopify store.</li>
                            <li className="mb-2">• You are responsible for the accuracy of data in your sheet.</li>
                            <li className="mb-2">• Do not use the App to upload illegal, harmful, or unauthorized content.</li>
                        </ul>
                    </section>

                    {/* 4. Data & Privacy */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">4. Data Handling</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            We access your Shopify store and Google Sheet <strong>only to perform sync operations</strong>.
                            We do not store your product data permanently.
                        </p>
                    </section>

                    {/* 5. Shopify API */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">5. Shopify API Usage</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            The App uses Shopify Admin API to read and write product data.
                            We respect Shopify’s rate limits and queue large jobs to avoid errors.
                        </p>
                    </section>

                    {/* 6. Limitations */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">6. Limitations</h2>
                        <ul className="list-unstyled text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                            <li className="mb-2">• Syncs over 1,000 products may take several minutes and run in the background.</li>
                            <li className="mb-2">• We are not responsible for data loss due to incorrect sheet edits.</li>
                            <li className="mb-2">• App performance depends on your internet and Shopify store speed.</li>
                        </ul>
                    </section>

                    {/* 7. No Warranty */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">7. No Warranty</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            The App is provided <strong>"as is"</strong> without warranty.
                            We do not guarantee 100% uptime or error-free syncs.
                        </p>
                    </section>

                    {/* 8. Changes */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">8. Changes to Terms</h2>
                        <p className="text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            We may update these terms. Continued use of the App means you accept the changes.
                        </p>
                    </section>

                    {/* 9. Contact */}
                    <section className="mb-5">
                        <h2 className="h5 fw-bold text-teal mb-3">9. Contact Us</h2>
                        <p className="text-muted me-2" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                            Questions? Email us at :
                            <a
                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=Support Request - Shopy Sync`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-teal"
                                style={{ marginLeft: '5px' }}
                            >
                                {supportEmail}
                            </a>
                        </p>
                    </section>


                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;